/**
 * WebSocket Debug Utilities
 *
 * Enable debug logging for WebSocket connections to diagnose connection issues.
 * This is especially useful for debugging offshore users or users with connection problems.
 */

export const wsDebug = {
  /**
   * Enable WebSocket debug logging
   * Usage: window.wsDebug.enable()
   */
  enable: () => {
    localStorage.setItem('ws:debug', 'true');
    console.log('%c[WS Debug] Enabled', 'color: #00ff00; font-weight: bold;');
    console.log('Reload the page to see WebSocket debug logs');
    console.log('You will see logs prefixed with [WS Connect], [WS Query], [WS Chat], etc.');
  },

  /**
   * Disable WebSocket debug logging
   * Usage: window.wsDebug.disable()
   */
  disable: () => {
    localStorage.removeItem('ws:debug');
    console.log('%c[WS Debug] Disabled', 'color: #ff0000; font-weight: bold;');
    console.log('Reload the page to stop seeing WebSocket debug logs');
  },

  /**
   * Check if debug logging is enabled
   * Usage: window.wsDebug.isEnabled()
   */
  isEnabled: () => {
    const enabled = localStorage.getItem('ws:debug') === 'true';
    console.log(`[WS Debug] Currently ${enabled ? 'enabled' : 'disabled'}`);
    return enabled;
  },

  /**
   * Show help information
   * Usage: window.wsDebug.help()
   */
  help: () => {
    console.log('%cWebSocket Debug Utilities', 'color: #00aaff; font-size: 16px; font-weight: bold;');
    console.log('');
    console.log('Available commands:');
    console.log('  %cwindow.wsDebug.enable()%c  - Enable debug logging', 'color: #ffaa00;', '');
    console.log('  %cwindow.wsDebug.disable()%c - Disable debug logging', 'color: #ffaa00;', '');
    console.log('  %cwindow.wsDebug.isEnabled()%c - Check if enabled', 'color: #ffaa00;', '');
    console.log('  %cwindow.wsDebug.help()%c - Show this help', 'color: #ffaa00;', '');
    console.log('');
    console.log('Debug logs to look for:');
    console.log('  • [WS Connect] - Socket connection attempts');
    console.log('  • [WS Connect Error] - Connection failures');
    console.log('  • [WS Config] - Socket configuration');
    console.log('  • [WS Session] - Session management');
    console.log('  • [WS Chat] - Chat socket operations');
    console.log('  • [WS Query] - Query socket operations');
    console.log('  • [WS Lifecycle] - Connect/disconnect events');
    console.log('');
    console.log('Common issues:');
    console.log('  1. No session ID → Check [WS Config] and [WS Session] logs');
    console.log('  2. Connection errors → Check [WS Connect Error] for details');
    console.log('  3. Not receiving updates → Check if [WS Query]/[WS Chat] shows successful subscription');
    console.log('  4. CORS errors → Connection will fail at [WS Connect Error] with CORS message');
  },
};

// Make it globally available for debugging
if (typeof window !== 'undefined') {
  (window as any).wsDebug = wsDebug;

  // Log instructions on page load
  const shouldShowHelp = false; // sessionStorage.getItem('ws:help-shown') !== 'true';
  if (shouldShowHelp) {
    console.log('%c💡 WebSocket Debug Utilities Available', 'color: #00aaff; font-size: 14px; font-weight: bold;');
    console.log('Type %cwindow.wsDebug.help()%c in the console for debugging commands', 'color: #ffaa00;', '');
    sessionStorage.setItem('ws:help-shown', 'true');
  }
}
